import { render, staticRenderFns } from "./CreateCampaign.vue?vue&type=template&id=1dc45f2a&scoped=true"
import script from "./CreateCampaign.vue?vue&type=script&lang=js"
export * from "./CreateCampaign.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaign.vue?vue&type=style&index=0&id=1dc45f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc45f2a",
  null
  
)

export default component.exports